import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRequestService } from '@gelato-api-ui/core/api/services/api-request.service';
import { CompanyDetails } from '@gelato-api-ui/core/company-details/company-details';
import { QuestionnaireUpdateRequest } from '@gelato-api-ui/core/quick-questions/types/questionnaire-update-request';

@Injectable({ providedIn: 'root' })
export class QuestionnaireApiService {
  constructor(private apiRequestService: ApiRequestService) {}

  save(clientId: string, request: QuestionnaireUpdateRequest): Observable<CompanyDetails> {
    return this.apiRequestService
      .put<CompanyDetails>(`/api/identity/v3/clients/${clientId}/questionnaire`, {
        body: request,
      })
      .pipe(map((response: any) => response.data));
  }
}
